
export interface PotionDescriptor {
  readonly name: string;
  readonly token:string;
  readonly description:string;
  readonly icon: string;
  readonly address: string;
}

const potions = [
  {
    name:"Minor Health Potion",
    token:"MHP",
    description: "A health potion with limited healing properties, offering 70 health in combat when consumed.",
    icon: "https://storage.googleapis.com/crypto-raiders-assets/web/currencies/minor_health_potion1.png",
    address: "0x919B22450c38108bB624c4c72B085Cd7C0442b80"
  },
  {
    name:"Basic Health Potion",
    token:"BHP",
    description: "The second-tier health potion, for restoring 200 health in combat.",
    icon: "https://storage.googleapis.com/crypto-raiders-assets/web/currencies/basic_health_potion.png",
    address:"0xe3D73635CF43551d245A551C8Cf909A8475299bb"
  },
  {
    name:"Minor Damage Potion",
    token:"MDP",
    description: "A damage potion that gives the consumer a small buff to damage.",
    icon: "https://storage.googleapis.com/crypto-raiders-assets/web/currencies/minor_damage_potion.png",
    address: "0xfc5970E9129BBD3822ad7932598344c7Ff3731CB"
  },
  {
    name:"Basic Damage Potion",
    token:"BDP",
    description: "The second-tier damage potion, giving even more extra damage.",
    icon: "https://storage.googleapis.com/crypto-raiders-assets/web/currencies/basic_damage_potion.png",
    address:"0xbd10aebc663ec8324aC153AF04c34Dad2d8ecC81"
  },


] as PotionDescriptor[];

export default potions;
